import { logBlurOrFocusEvent } from './util/logFunctions';
// @ts-expect-error untyped import
import { blurHandler, changeHandler } from './handlers';
import type { HandlersTypes } from '@/types';

export const formInputHandlers: HandlersTypes = {
  blurHandler,
  changeHandler,
  focusHandler: logBlurOrFocusEvent,
};
